module.exports = __webpack_public_path__ + "1c8b0cc4c228b72c244429e33d3f0cde.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbal-peel/ingredients/marshmallow.jpg
 ** module id = 454
 ** module chunks = 0
 **/